import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconSocialPinterestDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 2.5c-5.523 0-10 4.477-10 10 0 4.236 2.636 7.858 6.356 9.315-.088-.791-.167-2.008.034-2.872.182-.78 1.173-4.97 1.173-4.97s-.3-.6-.3-1.485c0-1.39.807-2.428 1.81-2.428.854 0 1.266.64 1.266 1.408 0 .858-.547 2.14-.829 3.33-.235.995.5 1.807 1.481 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.394-1.72-4.068-4.177-4.068-2.846 0-4.516 2.134-4.516 4.34 0 .86.331 1.78.745 2.282a.3.3 0 0 1 .069.287c-.076.316-.245.995-.278 1.134-.043.183-.145.222-.334.134-1.25-.582-2.03-2.408-2.03-3.875 0-3.154 2.292-6.05 6.607-6.05 3.47 0 6.165 2.471 6.165 5.775 0 3.446-2.173 6.22-5.189 6.22-1.013 0-1.966-.527-2.292-1.149 0 0-.502 1.91-.623 2.377-.226.87-.835 1.958-1.243 2.622.936.29 1.93.446 2.961.446 5.523 0 10-4.477 10-10s-4.477-10-10-10" clipRule="evenodd" /></svg></>;
}
IconSocialPinterestDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconSocialPinterestDefault;